module.exports = __webpack_public_path__ + "static/img/ny-05-EVENTS.c929604f.jpg";